<!--
 * @Author: yl 1871883713@qq.com
 * @Date: 2024-03-14 09:34:32
 * @LastEditors: yl 1871883713@qq.com
 * @LastEditTime: 2024-06-19 10:50:49
 * @Description: 
-->
<template>
	<div class="advisory-list">
    <div class="smart-robot" @click="showSmart =!showSmart">
      <img src="https://openim-1309784708.cos.ap-shanghai.myqcloud.com/ad0432580355bb14b4603dc6b05f0b45.gif" class="eye-img">
      <img src="https://openim-1309784708.cos.ap-shanghai.myqcloud.com/4a337c4e7aaf8eee946ad584b9ddc53d.png" class="bot-img">
    </div>
		<article class="bs-contact-us">
			<section
				class="contact-button phone-contact"
				slot="reference"
				@click="goApplyDemo()"
			>
				<i class="iconfont iconzixun"></i>
				<span>免费咨询</span>
			</section>
			<el-popover
				placement="left"
				width="200"
				trigger="hover"
				content="400-011-1850"
			>
				<section class="iphone">
					<div class="title">服务热线</div>
					<div class="iphone-number">023-68682379</div>
				</section>
				<section
					class="contact-button phone-contact"
					slot="reference"
				>
					<i class="el-icon-mobile-phone"></i>
					<span>电话咨询</span>
				</section>
			</el-popover>
			<el-popover
				placement="left"
				width="300"
				trigger="hover"
			>
				<div class="qr-container">
					<section class="qr-code-box">
						<div class="qr-code">
							<img
							src="https://openim-1309784708.cos.ap-shanghai.myqcloud.com/79c8a4509739c515576fc58840adb074.jpg"
							/>
						</div>
						<div class="qr-code-name">飞椽</div>
					</section>
					<section class="qr-code-box">
						<div class="qr-code">
							<img
								src="https://static.bimcc.com/openim/BIMCC%E7%AD%91%E4%BA%91%E5%85%AC%E4%BC%97%E5%8F%B7%E4%BA%8C%E7%BB%B4%E7%A0%81%281%29657B359934AD8920B4176BAE2B2E1D1E.png"
							/>
						</div>
						<div class="qr-code-name">筑云科技</div>
					</section>
				</div>
				<section
					class="contact-button weixin-contact"
					slot="reference"
				>
					<i class="el-icon-chat-dot-round"></i>
					<span>微信咨询</span>
				</section>
			</el-popover>
		</article>
		<div
			class="contact-button back-top"
			id="upbutton"
			@click="clickHandler"
		>
			<i class="el-icon-upload2"></i>
		</div>
    <SmartRobotChat :showSmart="showSmart" @close="close()"></SmartRobotChat>
	</div>
</template>

<script>
import { Popover } from 'element-ui';
import SmartRobotChat from './SmartRobotChat.vue'
export default {
	name: 'FixTools',
	components: {
    
    SmartRobotChat,
		'el-popover': Popover,
	},
	props: {},
	data() {
		return {
			// 滚动条距顶长度
			distanceY: null,
      showBot:false,
      showSmart:false
		};
	},
	mounted() {},
	methods: {
    close(){
      this.showSmart = false
    },
    // showSmart(){

    // },
		goApplyDemo() {
			this.$router.push({ name: 'ApplyDemo' });
		},
		// 回到网页顶部
		clickHandler() {
			this.$nextTick(() => {
				let timer = setInterval(function () {
					this.distanceY = document.getElementById('content').scrollTop;
					if (this.distanceY == 0) {
						clearInterval(timer);
						return;
					}
					let speed = Math.ceil(this.distanceY / 16);
					document.getElementById('content').scrollTop = this.distanceY - speed;
				}, 16);
			});
		}
	}
};
</script>

<style lang="less" scoped>
.qr-container {
	display: flex;
	justify-content: center;
	gap: 16px;
	align-items: center;
	.qr-code-box {
		text-align: center;
		.qr-code {
			img {
				width: 108px;
				height: 108px;
			}
		}
	}
}
.iphone {
	.title {
		padding-bottom: 5px;
		box-sizing: border-box;
		font-size: 14px;
	}
	.iphone-number {
		color: #3571e9;
		font-size: 16px;
		font-weight: bold;
	}
}
.advisory-list {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: fixed;
	top: 32%;
	right: 10px;
	width: 72px;
	height: 298px;
	border-radius: 4px;
	z-index: 998;
	animation-name: translateAnimation;
	animation-duration: 1s;
	animation-iteration-count: 1;
	@keyframes translateAnimation {
		0% {
			transform: translateX(100px);
		}
		100% {
			transform: translateX(0);
		}
	}
  .smart-robot{
    width: 63px;
    height:100px;
    position: absolute;
    top: -100px;
    right: -6px;
    .eye-img{
      width: 16px;
      height: 16px;
      transform: rotate(330.7deg);
      position: absolute;
      top: 26px;
      left: 36px;
    }
    .bot-img{
      width: 100%;
      height: 100%;
    }
  }
	.bs-contact-us {
		background: #fff;
		border-radius: 4px;
		.contact-button {
			display: flex;
			flex-direction: column;
			align-items: center;
			display: -webkit-box;
			display: -ms-flexbox;
			display: -webkit-flex;
			position: relative;
			width: 72px;
			height: 72px;
			padding: 30px 0;
			box-sizing: border-box;
			text-align: center;
			cursor: pointer;
			border-radius: 4px;
			-webkit-box-pack: center;
			-ms-flex-pack: center;
			-webkit-justify-content: center;
			justify-content: center;
			-webkit-box-orient: vertical;
			-webkit-box-direction: normal;
			-webkit-flex-direction: column;
			-ms-flex-direction: column;
			-webkit-transition: background-color 218ms;
			transition: background-color 218ms;
			i {
				padding-bottom: 10px;
				box-sizing: border-box;
				color: #3571e9;
				font-size: 22px;
			}
			span {
				font-size: 12px;
				line-height: 10px;
			}
		}
		.contact-button:hover {
			background: #3571e9;
			i {
				color: #fff;
			}
			span {
				color: #fff;
			}
		}
	}
	.contact-button {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: relative;
		width: 72px;
		height: 72px;
		background: #fff;
		text-align: center;
		cursor: pointer;
		border-radius: 4px;
		-webkit-transition: background-color 218ms;
		transition: background-color 218ms;
		/*动画效果*/
		outline: none;
		transition: all 0.3s ease-in-out;
		-webkit-transition: all 0.3s ease-in-out;
		-moz-transition: all 0.3s ease-in-out;
		-o-transition: all 0.3s ease-in-out;
		-ms-transition: all 0.3s ease-in-out;
		i {
			padding-bottom: 10px;
			box-sizing: border-box;
			color: #3571e9;
			font-size: 36px;
		}
	}
	.contact-button:hover {
		background: #3571e9;
		i {
			color: #fff;
		}
		span {
			color: #fff;
		}
	}
}
.smart-chat-wrap .mask {
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.7);
	.img {
		width: 150px;
		height: 150px;
		img {
			width: 100%;
			height: 100%;
		}
	}
}
</style>
